/**
 * Created by aheshperera
 * 12/3/18
 * */

import config from '../config';

// BFF Base URL
export const BFF_API_BASE_URL = config.bff.URL;

const PC_PRICING_APPS = config.app.PCP;
const RME_URL = config.app.RME;
const SALESFORCE_URL = config.app.SALESFORCE;
const CDM_PUBLIC_URL = config.app.CDM_PUBLIC;
const { OKTA_PASSWORD_RESET_URL } = config.app;

// BFF URLs
export const URLS = {
  GET_COOKIE_URL: `${BFF_API_BASE_URL}/auth/getCookie`,
  BIS_FILES_URL: `${BFF_API_BASE_URL}/files/bis`,
  FILE_TRANSFER_DETAILS_URL: `${BFF_API_BASE_URL}/files/transfer-details`,
  ATTACHMENT_DOWNLOAD_URL: `${BFF_API_BASE_URL}/files/download/attachment`,
  VENDOR_FILE_IMPORT_URL: `${BFF_API_BASE_URL}/vendor-file-import`,
  AGREEMENT_FILE_IMPORT_URL: `${BFF_API_BASE_URL}/agreements/import`,
  UPLOAD_SIGNED_URL_GENERATION_URL: `${BFF_API_BASE_URL}/files/signed-url/upload`,
  DOWNLOAD_SIGNED_URL_GENERATION_URL: `${BFF_API_BASE_URL}/files/signed-url/download`,
  VENDOR_PRICE_FILES_IMPORT_LOG_URL: `${BFF_API_BASE_URL}/files/log/vendor-price-import`,
  FILES_DOWNLOAD_URL: `${BFF_API_BASE_URL}/files/download`,
  USER_DETAILS_URL: `${BFF_API_BASE_URL}/user/details`,
  DATADOG_SECRETS_URL: `${BFF_API_BASE_URL}/secrets/datadog-secrets`,
  USER_PROFILE_DETAILS_URL: `${BFF_API_BASE_URL}/user/profile`,
  MY_PROFILE_DETAILS_URL: `${BFF_API_BASE_URL}/user/myprofile`,
  USER_PROFILE_MANAGEMENT_DETAILS_URL: `${BFF_API_BASE_URL}/user/management/profile`,
  USER_SUPERVISOR_ASSOCIATION_URL: `${BFF_API_BASE_URL}/user/management/profile/supervisor`,
  USER_VENDORS_ASSOCIATION_URL: `${BFF_API_BASE_URL}/user/management/profile/vendors`,
  USER_VENDORS_ASSOCIATION_FILE_IMPORT_URL: `${BFF_API_BASE_URL}/user/management/profile/internal/vendors/import`,
  ALL_USER_GROUPS_URL: `${BFF_API_BASE_URL}/user/groups`,
  USER_GROUPS_URL: `${BFF_API_BASE_URL}/user/management/profile/groups`,
  GET_USER_GROUP_ASSOCIATIONS_URL: `${BFF_API_BASE_URL}/user/management/profile/group-associations`,
  USER_ASSOCIATION_AND_BUSINESS_CENTERS_CONTACTS_URL: `${BFF_API_BASE_URL}/vendors/user-associations`,
  USERS_URL: `${BFF_API_BASE_URL}/users`,
  REPORT_DETAILS_URL: `${BFF_API_BASE_URL}/reports/log`,
  REPORT_DATA_URL: `${BFF_API_BASE_URL}/reports/grid`,
  REPORT_METADATA_URL: `${BFF_API_BASE_URL}/reports/metadata`,
  REPORT_TEMPLATES_URL: `${BFF_API_BASE_URL}/reports/templates`,
  AGREEMENT_REPORT_URL: `${BFF_API_BASE_URL}/reports/agreements`,
  COST_DATA_URL: `${BFF_API_BASE_URL}/cost-data`,
  VENDORS_FETCH_URL: `${BFF_API_BASE_URL}/vendors`,
  WORKSPACE_SUPPLIER_SUPPORT_REQUEST_SUBMISSION_URL: `${BFF_API_BASE_URL}/workspace/supplier-support-request/submit`,
  WORKSPACE_SUPPLIER_SUPPORT_REQUEST_TYPES_URL: `${BFF_API_BASE_URL}/workspace/supplier-support-request/types`,
  WORKSPACE_HELP_TOPICS_URL: `${BFF_API_BASE_URL}/workspace/help-topics`,
  WORKSPACE_HELP_TOPIC_DETAILS_URL: `${BFF_API_BASE_URL}/workspace/help-topic-details`,
  WORKSPACE_RECENT_ACTIVITIES_URL: `${BFF_API_BASE_URL}/workspace/recent-activities`,
  WORKSPACE_REQUEST_SUBMISSION_URL: `${BFF_API_BASE_URL}/workspace/workspace-request/submit`,
  WORKSPACE_REQUEST_DETAILS_URL: `${BFF_API_BASE_URL}/workspace/requests`,
  MASTER_DATA_URL: `${BFF_API_BASE_URL}/master-data`,
  LOGIN_URL: `${BFF_API_BASE_URL}/auth/login`,
  LOGOUT_URL: `${BFF_API_BASE_URL}/auth/logout`,
  CDM_PUBLIC_URL: `${CDM_PUBLIC_URL}/login`,
  ENTERPRISE_COST_URL: `${BFF_API_BASE_URL}/enterprise-data`,
  AGREEMENT_SEARCH_REQUEST_URL: `${BFF_API_BASE_URL}/agreements/agreement-item-detail/search`,
  AGREEMENTS_SEARCH_REQUEST_URL: `${BFF_API_BASE_URL}/agreements/search`,
  EARNED_INCOME_MAPPINGS_REQUEST_URL: `${BFF_API_BASE_URL}/utilities/earned-income-mappings`,
  VENDOR_BASES_FETCH_URL: `${BFF_API_BASE_URL}/agreements/vendor-bases`,
  AGREEMENT_ASSOCIATED_VENDORS_FETCH_URL: `${BFF_API_BASE_URL}/agreements/vendors`,
  BUSINESS_CENTERS_FETCH_URL: `${BFF_API_BASE_URL}/agreements/business-centers`,
  SAS_FD_DETAILS_FETCH_URL: `${BFF_API_BASE_URL}/agreements/sas-fd-details`,
  VENDOR_SAS_VALUE_UPDATE_URL: `${BFF_API_BASE_URL}/agreements/vendor/update-sas-value`,
  VENDOR_SAS_VALUE_ADD_URL: `${BFF_API_BASE_URL}/agreements/vendor/add-sas-value`,
  SAS_FD_FILE_IMPORT_URL: `${BFF_API_BASE_URL}/agreements/items/sas-fd-file-import`,
  ITEM_SAS_FD_DETAILS_UPDATE_URL: `${BFF_API_BASE_URL}/agreements/items/update-sas-fd-details`,
  ITEM_GROUP_MANAGEMENT_BASE_URL: `${BFF_API_BASE_URL}/agreements/item-groups`,
  SUPPLIER_PROFILE_DETAILS_URL: `${BFF_API_BASE_URL}/supplier/profile`,
  SUPPLIER_ONBOARD_DETAILS_URL: `${BFF_API_BASE_URL}/supplier/profile/onboard-details`,
  UPDATE_SUPPLIER_CONTACTS_URL: `${BFF_API_BASE_URL}/supplier/supplier-contacts`,
  LEGACY_AGREEMENT_ENDPOINT_URL: `${BFF_API_BASE_URL}/legacy-agreements`,
  AGREEMENT_MAINTENANCE_ENDPOINT_URL: `${BFF_API_BASE_URL}/agreements`,
  ITEM_GROUPS_MAINTENANCE_ENDPOINT_URL: `${BFF_API_BASE_URL}/item-groups`,
  ITEM_GROUP_BASE_URL: `${BFF_API_BASE_URL}/agreements/item-groups`,
  FORMULA_GROUP_BASE_URL: `${BFF_API_BASE_URL}/formula-groups`,
  COST_IMPACT_TERM_FILE_IMPORT_URL: `${BFF_API_BASE_URL}/agreements/ei-terms-file-import`,
  COST_IMPACT_TERM_DETAILS_FETCH: `${BFF_API_BASE_URL}/agreements/ei-terms-details`,

  MODULE_PRICE_IMPORT_URL: `${BFF_API_BASE_URL}/module-pricing/file-import`,
  MODULES_FETCH_URL: `${BFF_API_BASE_URL}/module-pricing/modules`,
  MODULE_PRICE_EXPORT_URL: `${BFF_API_BASE_URL}/module-pricing/file-export`,
  ITEM_PRICE_URL: `${BFF_API_BASE_URL}/module-pricing/item-price`,
  MODULE_GROUP_CREATE: `${BFF_API_BASE_URL}/module-pricing/modules`,
  COMMODITIES_FETCH_URL: `${BFF_API_BASE_URL}/module-pricing/comm_codes`,
  COMMODITY_GROUP_CREATE: `${BFF_API_BASE_URL}/module-pricing/comm_codes`,
  FECTCH_COMMODITY_GROUP: `${BFF_API_BASE_URL}/module-pricing/comm_codes`,
  MODULES_ASSOCIATIONS: `${BFF_API_BASE_URL}/module-pricing/module-associations`,
  DELETE_MODULE_GROUP: `${BFF_API_BASE_URL}/module-pricing/modules/{moduleId}`,
  UPDATE_MODULE_GROUP: `${BFF_API_BASE_URL}/module-pricing/modules/{moduleId}`,
  LOADING_ARES_FETCH_URL: `${BFF_API_BASE_URL}/module-pricing/loading-areas`,
  MODULE_GROUP_COMMODITY_ASSIGNMENT: `${BFF_API_BASE_URL}/module-pricing/{moduleId}/comm_codes`,
  MODULE_GROUP_LOADING_AREA_ASSIGNMENT: `${BFF_API_BASE_URL}/module-pricing/{moduleId}/loading-areas`,
  UPDATE_COMMODITY_GROUP: `${BFF_API_BASE_URL}/module-pricing/comm_codes/{comcodeId}`,
  DELETE_COMMODITY_GROUP: `${BFF_API_BASE_URL}/module-pricing/comm_codes/{comcodeId}`,
  COMMODITY_GROUP_ITEM_ASSIGNMENT: `${BFF_API_BASE_URL}/module-pricing/comm_codes/{comcodeId}/items`,
  PRICE_MODULE_ITEMS_FETCH_URL: `${BFF_API_BASE_URL}/module-pricing/items`,
  FETCH_LOADING_AREA_DETAILS: `${BFF_API_BASE_URL}/module-pricing/loading-areas/{loadingAreaId}`,
  CREATE_LOADING_AREA: `${BFF_API_BASE_URL}/module-pricing/loading-areas`,
  DELETE_LOADING_AREA: `${BFF_API_BASE_URL}/module-pricing/loading-areas/{loadingAreaId}`,
  UPDATE_LOADING_AREA: `${BFF_API_BASE_URL}/module-pricing/loading-areas/{loadingAreaId}`,

  REACTIVATE_MODULE_GROUP: `${BFF_API_BASE_URL}/module-pricing/modules/reactivate/{moduleId}`,
  REACTIVATE_COMMODITY_GROUP: `${BFF_API_BASE_URL}/module-pricing/comm_codes/reactivate/{commodityId}`,
  REACTIVATE_LOADING_AREA: `${BFF_API_BASE_URL}/module-pricing/loading-areas/reactivate/{loadingAreaId}`,

  UPDATE_MODULE_PRICES: `${BFF_API_BASE_URL}/module-pricing/prices`,

  SEGMENT_DETAILS_URL: `${BFF_API_BASE_URL}/segment`,
  GET_SEGMENT_CODES_URL: `${BFF_API_BASE_URL}/segment/codes`,
  GET_SEGMENT_CODE_VERSIONS_URL: `${BFF_API_BASE_URL}/segment/codes/versions`,
  GET_SEGMENT_VENDOR_MAPPING_URL: `${BFF_API_BASE_URL}/segment/segment-vendor-mapping`,

};

export const EXTERNAL_APPS_URLS = {
  PCP_P1_URL: PC_PRICING_APPS.P1,
  PCP_P2_URL: PC_PRICING_APPS.P2,
  RME_URL,
  SALESFORCE_URL,
  OKTA_PASSWORD_RESET_URL
};

export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH'
};

export const HTTP_CONTENT_TYPE = {
  APPLICATION_OCTET_STREAM: 'application/octet-stream',
  APPLICATION_JSON: 'application/json',
};

export const VENDOR_FILE_PROCESS_TYPES = {
  CREATE_VARIATION_REPORT: 'CREATE_VARIATION_REPORT',
  PRICE_LOAD: 'PRICE_LOAD'
};

export const FILE_TYPES = {
  CORPORATE_PROGRAM: 'CORPORATE_PROGRAM',
  VENDOR_PRICE_FILE: 'VENDOR_PRICE_FILE',
  GENERAL_WORKSPACE_ATTACHMENT: 'GENERAL_WORKSPACE_ATTACHMENT',
  AGREEMENT_COMMENT_ATTACHMENT: 'AGREEMENT_COMMENT_ATTACHMENT',
  TEMP_WORKSPACE_DATA_OBJECT: 'TEMP_WORKSPACE_DATA_OBJECT',
  ADHOC_COST_FILE: 'ADHOC_COST_FILE',
  ADHOC_COST_FILE_MASS_UPLOAD: 'ADHOC_COST_FILE_MASS_UPLOAD',
  BASE_12_REQUEST: 'BASE_12_REQUEST',
  VENDOR_ASSOCIATION_FILE_IMPORT_REQUEST: 'VENDOR_ASSOCIATION_FILE_IMPORT_REQUEST',
  VENDOR_ASSOCIATION_MASS_UPDATE_WORKSHEET_TEMPLATE: 'VENDOR_ASSOCIATION_MASS_UPDATE_WORKSHEET_TEMPLATE',
  ITEM_GROUP_MASS_ITEM_ASSOCIATION_FILE: 'ITEM_GROUP_MASS_ITEM_ASSOCIATION_FILE',
  MARKET_GROUP_MASS_ITEM_ASSOCIATION_WORKSHEET_TEMPLATE: 'MARKET_GROUP_MASS_ITEM_ASSOCIATION_WORKSHEET_TEMPLATE',
  MARKET_GROUP_MASS_ITEM_ASSOCIATION_FILE: 'MARKET_GROUP_MASS_ITEM_ASSOCIATION_FILE',
  SAS_FD_REQUEST: 'SAS_FD_REQUEST',
  SAS_FILE_IMPORT_TEMPLATE: 'SAS_FILE_IMPORT_TEMPLATE',
  SAS_FD_FILE_IMPORT_TEMPLATE: 'SAS_FD_FILE_IMPORT_TEMPLATE',
  ITEM_GROUP_MASS_ITEM_ASSOCIATION_WORKSHEET_TEMPLATE: 'ITEM_GROUP_MASS_ITEM_ASSOCIATION_WORKSHEET_TEMPLATE',
  OVERAGE_REQUEST: 'OVERAGE',
  OVERAGE_MAINTENANCE_FILE_UPLOAD_TEMPLATE: 'OVERAGE_MAINTENANCE_FILE_UPLOAD_TEMPLATE',
  MODULE_PRICE_IMPORT_REQUEST: 'MODULE_PRICE_IMPORT_REQUEST',
  BASE_12_FILE_UPLOAD_TEMPLATE: 'BASE_12_FILE_UPLOAD_TEMPLATE',
};

export const CATALOG_COST_CHANGE_FILE_TYPES = {
  DEAR_VALUED_CUSTOMER_LETTER: {
    id: 'DEAR_VALUED_CUSTOMER_LETTER',
    label: 'Dear Valued Customer Letter',
    fileTypeLabel: '(.docx or .pdf)',
    maxFileCount: 1,
    maxFileSizeInMegabytes: 1,
    maxCumulativeFileSizeInMegabytes: 1,
    acceptedFileFormats: {
      value: 'application/pdf, .docx',
      label: 'Word (.docx) or PDF'
    },
    description: 'Signed price change letter informing ALL customers across ALL channels, including retail. (Max 1 file, up to 1MB)'
  },
  SUPPLIER_COST_CHANGE_IMPACT_WORKSHEET: {
    id: 'SUPPLIER_COST_CHANGE_IMPACT_WORKSHEET',
    label: 'Supplier Cost Change Impact',
    fileTypeLabel: '(.xls or .xlsx)',
    maxFileCount: 2,
    maxFileSizeInMegabytes: 10,
    maxCumulativeFileSizeInMegabytes: 20,
    templateId: 'SUPPLIER_COST_CHANGE_IMPACT_WORKSHEET_TEMPLATE',
    acceptedFileFormats: {
      value: '.xls, .xlsx',
      label: 'Excel (.xls or .xlsx)'
    },
    description: 'Current vs. New Pricing with Associated Cost Impact. Template is available, if needed. (Max 2 files, up to 10MB each)'
  },
  SYSCO_COST_FILE: {
    id: 'SYSCO_COST_FILE',
    label: 'Sysco Cost File(s)',
    fileTypeLabel: '(.csv)',
    maxFileCount: 2,
    maxFileSizeInMegabytes: 5,
    maxCumulativeFileSizeInMegabytes: 10,
    acceptedFileFormats: {
      value: '.csv',
      label: 'CSV'
    },
    description: 'Sysco Cost file with New Pricing (Max 2 files, up to 5MB each)'
  },
  NATIONAL_PRICE_LIST_WORKSHEET: {
    id: 'NATIONAL_PRICE_LIST_WORKSHEET',
    label: 'National Price List',
    fileTypeLabel: '(.xls or .xlsx)',
    maxFileCount: 1,
    maxFileSizeInMegabytes: 5,
    maxCumulativeFileSizeInMegabytes: 5,
    acceptedFileFormats: {
      value: '.xls, .xlsx',
      label: 'Excel (.xls or .xlsx)'
    },
    description: 'National Price List (Max 1 file, up to 5MB)'
  },
  SUPPORTING_JUSTIFICATION_DOCUMENTS: {
    id: 'SUPPORTING_JUSTIFICATION_DOCUMENTS',
    label: 'Supporting Justification Documents: Market Reports, Indexes for Commodities, etc.',
    fileTypeLabel: '(.docx, .pdf or .pptx)',
    maxFileCount: 4,
    maxFileSizeInMegabytes: 20,
    maxCumulativeFileSizeInMegabytes: 20,
    acceptedFileFormats: {
      value: 'application/pdf, .docx, .pptx',
      label: 'Word (.docx), PDF or PowerPoint (.pptx)'
    },
    description: 'Provide backup documentation justifying the price increase (Max 4 files, up to 20MB total)'
  },
  SYSCO_COST_COMPONENT_WORKSHEET: {
    id: 'SYSCO_COST_COMPONENT_WORKSHEET',
    label: 'Sysco Cost Component Worksheet',
    fileTypeLabel: '(.xlsx)',
    maxFileCount: 1,
    maxFileSizeInMegabytes: 3,
    maxCumulativeFileSizeInMegabytes: 3,
    templateId: 'SYSCO_COST_COMPONENT_WORKSHEET_TEMPLATE',
    acceptedFileFormats: {
      value: '.xlsx',
      label: 'Excel (.xlsx)'
    },
    description: 'Worksheet to analyze cost drivers - List key ingredients, packaging, overhead etc. Be as detailed as possible." Required Template available. (Max 1 file, up to 3MB each)'
  },
  DISCONTINUED_SKU_WORKSHEET: {
    id: 'DISCONTINUED_SKU_WORKSHEET',
    label: 'Inactive/Discontinued SKUs',
    fileTypeLabel: '(.xls or .xlsx)',
    maxFileCount: 1,
    maxFileSizeInMegabytes: 2,
    maxCumulativeFileSizeInMegabytes: 2,
    acceptedFileFormats: {
      value: '.xls, .xlsx',
      label: 'Excel (.xls or .xlsx)'
    },
    description: 'List of Discontinued or Inactive Items (Max 1 file, up to 2MB)'
  },
};

export const SERVER_TYPE = {
  P1: 'P1',
  P2: 'P2'
};

export const PROCESS_STATUS_TYPES = {
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE'
};

export const ROLES = {
  ENTERPRISE_COST_READ_ONLY_ASSOCIATE: 'EC-RO',
  COORDINATOR: 'CRDN',
  SPECIALIST: 'SPCL',
  SOURCING_SPECIALIST: 'SC-SPCL',
  SOURCING_LEADER: 'SC-LEAD',
  CATEGORY_MANAGEMENT_SPECIALIST: 'CAT-SPCL',
  CATEGORY_MANAGEMENT_LEADER: 'CAT-LEAD',
  PRODUCE_COORDINATOR: 'PROD-CRDN',
  PRODUCE_LEAD: 'PROD-LEAD',
};

export const PERMISSIONS = {
  VIEW_ALL_TRANSACTIONS: 'VEW-ALL',
  ASSOCIATED_TRANSACTION_VIEW: 'VEW-ASC',
  VIEW_PCP_FILES_FROM_S3: 'VEW-PCF',
  USER_MAINTENANCE: 'USR-MNT',
  USER_GROUP_MAINTENANCE: 'GRP-MNT',
  VIEW_DIRECT_REPORTS: 'VEW-DRP',
  VIEW_EXPLORER: 'VEW-EXP',
  VIEW_PCP_EXPLORER: 'VEW-EXP-PCP',
  VIEW_FILE_TRANSFER_LOG: 'VEW-FTL',
  VIEW_BIS_FILE_EXPLORER: 'VEW-EXP-BIS',
  IMPORT_VENDOR_COST_FILE: 'IMP-VCF',
  CREATE_VARIATION_REPORT: 'CRE-VAR',
  VIEW_COST_DATA_MANAGEMENT_DASHBOARD: 'VEW-CMD',
  IMPORT_AGREEMENT_REQUEST: 'IMP-AGR',
  VIEW_USER_DIRECTORY: 'VEW-UDR',
  EXECUTE_COST_AUDIT: 'EXC-CAD',
  MANAGE_TEMPLATE: 'MNG-TPL',
  MANAGE_PRIVATE_TEMPLATE: 'MNG-PTL',
  EXECUTE_LIMITED_COST_AUDIT: 'CAD-ASC',
  EXECUTE_COST_FILE: 'CFR-ALL',
  EXECUTE_LIMITED_COST_FILE: 'CFR-ASC',
  UPDATE_WORKSPACE_PROCESS_STATUS: 'UPT-WPS',
  INITIATE_ADHOC_COST_CHANGE: 'CRE-ACM',
  VIEW_ADHOC_COST_CHANGE: 'VEW-ACM',
  INITIATE_CATALOG_COST_CHANGE: 'CRE-CCM',
  PRICE_MODULE_UPLOAD: 'PRMP-UPL',
  PRICE_MODULE_VIEW: 'PRMG-VIEW',
  PRICE_MODULE_CRUD: 'PRMG-CRUD',
  VIEW_ENTERPRISE_COST_DATA: 'VEW-ECS',
  VIEW_COST_VIEW: 'VEW-COV',
  VIEW_UTILITIES: 'VEW-UTL',
  SUPPLIER_PROFILE_CREATE: 'CRE-SUP',
  SUPPLIER_PROFILE_EDIT: 'MOD-SUP',
  MARKET_GROUP_EDIT: 'MOD-MGP',
  VIEW_MARKET_GROUP: 'VEW-MGP',
  VIEW_SAS_FD: 'VEW-SFD',
  CREATE_AND_EDIT_SAS_FD: 'CRE-SFD',
  EDIT_NO_SAS_AND_SEND_NEGATIVE: 'MOD-NOS',
  AGREEMENT_CREATE: 'AGR-CRT',
  AGREEMENT_MODIFY: 'AGR-MOD',
  AGREEMENT_VIEW: 'AGR-VEW',
  AGREEMENT_SEARCH: 'AGR-SRC',
  AGREEMENT_RECALCULATION: 'AGR-REC',
  AGREEMENT_CLONE: 'AGR-CLO',
  EDIT_ITEM_GROUP: 'ITM-MOD',
  VIEW_ITEM_GROUP: 'ITM-VEW',
  CREATE_ITEM_GROUP: 'ITM-CRT',
  ITEM_SEARCH: 'ITM-SRC',
  EXECUTE_AGREEMENT_REPORTS: 'EXC-AGR-RPT',
  GENERATE_ITEM_GROUP_REPORTS: 'GEN-IGR',
  VIEW_OVERAGE_VALUES: 'CIEI-VIEW',
  OVERAGE_CRUD: 'CIEI-CRUD',
  VIEW_SEGMENT_DETAILS: 'VIEW-SEG',
  MODIFY_SEGMENT_DETAILS: 'MOD-SEG'
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE'
};

export const USER_FETCH_TYPES = {
  ALL: 'all', SUPERVISORS: 'supervisors', INTERNAL: 'internal'
};

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  OK: 200,
  TEMPORARY_REDIRECT: 307,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
};

export const IDENTITY_PROVIDER = {
  AZURE_AD: 'AzureAD',
  OKTA: 'Okta',
};

export const HOUSE_TYPES = {
  GLOBAL: 'GLOBAL',
  RDC: 'RDC'
};

export const ITEM_GROUP_REPORT_TYPES = {
  GROUPED: 'GROUPED',
  UNGROUPED: 'UNGROUPED'
};

export const BUSINESS_CENTERS = {
  BAKE: 'Bakery',
  BEEF: 'Beef',
  BEV: 'Beverage',
  BFPRPD: 'Beef Prepared',
  BRAND: 'Branded',
  CAN: 'Can',
  CANNED: 'Canned',
  CHEM: 'Chemicals',
  CONV: 'Convenience',
  DAIRY: 'Dairy',
  DDAIRY: 'DDairy Market',
  DISP: 'Disposable',
  EPROD: 'E Produced',
  ESALES: 'E Sales',
  FATS: 'Fats',
  GROC: 'Grocery',
  MED: 'Medicine',
  NPROD: 'National Produced',
  NPURC: 'National Purchased',
  PLTRY: 'Poultry',
  PORK: 'Pork',
  POT: 'Potato',
  PROD: 'Produced',
  SEAFD: 'Seafood',
  SUPP: 'Supplier Equipments',
  TXPROD: 'TX Produced',
  VEG: 'Vegetables'
};

export const RECORD_TYPES = {
  NEC: '630400',
  SEC: '630500'
};

export const PRICE_TYPE_ABBREVIATIONS = {
  GLOBAL: 'G',
  HOUSE: 'H',
  CONTRACT: 'C',
  REGION: 'L',
  BRACKET: 'B',
};

export const PRICE_TYPES = {
  GLOBAL: 'GLOBAL',
  HOUSE: 'HOUSE',
  CONTRACT: 'CONTRACT',
  BRACKET: 'BRACKET',
  REGION: 'REGION',
};

export const VENDOR_SELL_METHODS = {
  FOB: 'FOB',
  DELIVERED: 'DELIVERED',
};

export const VENDOR_SELL_METHOD_ABBREVIATIONS = {
  FOB: 'CP',
  DELIVERED: 'DP',
};

export const REPORT_TYPES = {
  COST_AUDIT_GRID: 'COST_AUDIT_GRID',
  BASIS_DISCREPANCY_AD: 'BASIS_DISCREPANCY_AD',
  AGREEMENT_SUMMARY_AD: 'AGREEMENT_SUMMARY_AD',
  ITEM_GROUPING: 'ITEM_GROUPING'
};

export const DATA_TYPES = {
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  TEXT: 'TEXT'
};

export const USER_TYPES = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL'
};

export const CALCULATION_METHOD = {
  COST_PLUS: 'Cost Plus',
  SELL_MINUS: 'Sell Minus',
  SPC: 'SPC',
  COST_PLUS_VARIATION: 'Cost Plus Variation',
  SQUEEZE: 'Squeeze',
};

export const MGM_REQUEST_TYPES = {
  CREATE_MARKET_GROUP: 'CREATE_MARKET_GROUP',
  DELETE_MARKET_GROUP: 'DELETE_MARKET_GROUP',
  UPDATE_MARKET_GROUP: 'UPDATE_MARKET_GROUP',
  ADD_MARKET_GROUP_ITEMS: 'ADD_MARKET_GROUP_ITEMS',
  DELETE_MARKET_GROUP_ITEMS: 'DELETE_MARKET_GROUP_ITEMS',
  MASS_ITEM_ASSOCIATION: 'MASS_ITEM_ASSOCIATION',
};

export const REQUEST_TYPES = {
  SUPPLIER_SUPPORT_REQUEST: 'SUPPLIER_SUPPORT_REQUEST',
  VENDOR_COST_FILE: 'VENDOR_COST_FILE',
  VENDOR_COST_AUDIT: 'VENDOR_COST_AUDIT',
  VENDOR_AGREEMENT_AUDIT: 'VENDOR_AGREEMENT_AUDIT',
  VENDOR_COST_ADHOC: 'VENDOR_COST_ADHOC',
  SYGMA_COST_CHANGE: 'SYGMA_COST_CHANGE',
  VENDOR_COST_CATALOG: 'VENDOR_COST_CATALOG',
  BIS_COST_CHANGE: 'BIS_COST_CHANGE',
  MARKET_GROUP_MAINTENANCE: 'MARKET_GROUP_MAINTENANCE',
  MARKET_GROUP_PRICING: 'MARKET_GROUP_PRICING',
  COMMODITY_COST_CHANGE: 'COMMODITY_COST_CHANGE',
  RECALCULATION: 'RECALCULATION',
  ITEM_GROUP_MASS_ITEM_UPLOAD: 'ITEM_GROUP_MASS_ITEM_UPLOAD',
};

export const REQUEST_STATUS_TYPES = {
  RECEIVED: 'RECEIVED',
  REVIEW_IP: 'REVIEW_IP',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
  REVIEWED: 'REVIEWED',
  REVIEW_COMPLETED: 'REVIEW_COMPLETED',
  RESOLVED: 'RESOLVED',
  PENDING_PRICE_LOAD: 'PENDING_PRICE_LOAD',
  PENDING_LEAD_APPROVAL: 'PENDING_LEAD_APPROVAL'
};

export const AGREEMENT_STATUS_TYPES = {
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const REQUEST_ACTION_TYPES = {
  SUBMIT: 'SUBMIT',
  VIEW: 'VIEW',
  MODIFY: 'MODIFY',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  RESOLVE: 'RESOLVE',
  EXECUTE_VARIATION: 'EXECUTE_VARIATION',
  COMMENT: 'COMMENT',
  ASSIGNMENT: 'ASSIGNMENT',
  CALCULATE: 'CALCULATE',
  REVIEWED: 'REVIEWED',
};

export const COST_RECORD_STATUS = {
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
  STAGED: 'STAGED',
  REVIEW_IP: 'REVIEW_IP',
  LOADED: 'LOADED'
};

export const EARNED_INCOME_BUCKETS = {
  BASE_MAPPINGS: {
    BASE1: 'Vendor Disc',
    BASE2: 'Vendor Allow',
    BASE3: 'SMR',
    BASE4: 'OPCO Fund',
    BASE5: 'Overhead',
    BASE6: 'Brand Manager',
    BASE7: 'Promo',
    BASE8: 'Cash Disc Diff',
    BASE9: 'Additional SMR',
    BASE10: 'QA',
    BASE11: 'Base 11',
    BASE12: 'Base 12',
    BASE13: 'OPCO Promo Fund',
  },
  OPCO_EXCEPTIONS: {
    OPCO1: 'Market SMR',
    OPCO2: 'Owned Equip',
    OPCO3: 'Leased Equip',
    OPCO4: 'Marketing Fund',
    OPCO5: 'Misc Opco 1',
    OPCO6: 'Misc Opco 2',
  },
  WAREHOUSE_EXCEPTIONS: {
    WHSE1: 'Handling',
    WHSE2: 'Storage',
    WHSE3: 'Interest',
    WHSE4: 'Freight In',
    WHSE5: 'Misc Whse 1',
    WHSE6: 'Misc Whse 2',
  }
};

export const COSTING_ERROR = {
  COST_FORCED_DOWN: 'Cost Forced Down',
};

export const ASSIGNEE_TYPES = {
  INTERNAL_REQUEST_OWNER: 'INTERNAL_REQUEST_OWNER',
  REVIEWER: 'REVIEWER',
  APPROVER: 'APPROVER',
  getValue(key) {
    if (key === 0) return this.INTERNAL_REQUEST_OWNER;
    if (key === 1) return this.REVIEWER;
    if (key === 2) return this.APPROVER;
    return 'Invalid Key';
  }
};

export const P1_PRICE_RECORD_TYPES = {
  GLOBAL: 'GLOBAL',
  SYSCO_HOUSE: 'SYSCO HOUSE',
  SYGMA_HOUSE: 'SYGMA HOUSE',
  CONTRACT: 'CONTRACT',
  REGION: 'REGION',
  BRACKET: 'BRACKET',
};

export const FILE_EXTENSIONS = {
  PDF: 'pdf',
  EXCEL: 'xlsx',
  MS_EXCEL: 'application/vnd.ms-excel',
  PNG: 'png',
  JPEG: 'jpeg',
  JPG: 'jpg',
  WORD: 'docx',
  CSV: 'csv',
  POWERPOINT: 'pptx'
};

export const FILE_MIME_TYPE = {
  CSV: '.csv,text/csv',
  EXCEL: '.xlsx,application/vnd.ms-excel',
};

export const OWNED_RECORDS_INDICATOR = {
  SET: 'SET',
  UNSET: 'UNSET',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const TRANSFORM_HTTP_MESSAGE = {
  ALLOW: 'allow',
  DENY: 'deny',
};

export const DATETIME_FORMAT = {
  MMDDYYYY_HHMMSS: 'MM/DD/YYYY HH:mm:ss',
  MMDDYYYY: 'MM/DD/YYYY',
  MMMM_DD_YYYY_HHMMSS_A: 'MMMM DD,YYYY hh:mm:ss a',
  YYYYMMDD_HHMMSS: 'YYYY-MM-DD HH:mm:ss',
  YYYYMMDD: 'YYYY-MM-DD',
  MMMM_DD_YYYY: 'MMMM DD, YYYY',
};

export const CHARACTER = {
  SLASH: '/',
  DASH: '-'
};

export const CHANGE_VALUE_BASIS_TYPES = {
  PERCENTAGE: '%',
  CS: 'CS',
  LB: 'LB',
  NTWT: 'NTWT',
};

export const PRICE_CHANGE_CATEGORIES = {
  BAKE: 'Bakery',
  BEEF_BFPRPD: 'Beef/Beef Prepared',
  BEV: 'Beverage',
  CANNED: 'Canned',
  CHEM: 'Chemical',
  CONV: 'Convenience',
  DAIRY: 'Dairy',
  DISP: 'Disposables',
  FATS_OILS: 'Fats/Oils',
  FRZNVEG_POT: 'Frozen Veg/Potato',
  GROC: 'Grocery',
  PORK: 'Pork',
  PLTRY: 'Poultry',
  SEAFD: 'Seafood',
};

export const ASSOCIATION_TYPES = {
  COSTING: 'COSTING',
  LEAD: 'LEAD',
  SOURCING: 'SOURCING'
};

export const AGREEMENT_ACTIONS = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  CLONE: 'CLONE',
  RECALCULATE: 'RECALCULATE',
  DELETE: 'DELETE'
};

export const MAX_PAYLOAD_SIZE_IN_BYTES = 943720;
export const US_DATE_FORMAT = 'mm-dd-yyyy';
export const MILLISECONDS_PER_MINUTE = 60000;

export const COST_HEADER_INFO = [
  { label: 'Row ID', field: 'rowId' },
  { label: 'Vendor', field: 'supplier' },
  { label: 'Item', field: 'item' },
  { label: 'Business Center', field: 'businessCenter' },
  { label: 'House', field: 'house' },
  { label: 'Warehouse', field: 'warehouse' },
  { label: 'SMS Cost', field: 'smsCost' },
  { label: 'SMS Sell', field: 'marketPrice' },
  { label: 'Net Base', field: 'netBase' },
];

export const AGREEMENT_SUMMARY_INFO = [
  { label: 'Master Agreement Number', field: 'masterAgreementNumber', showLabelToolTip: true },
  {
    label: 'Agreement Description', field: 'agreementDescription', showLabelToolTip: true, showValueToolTip: true
  },
  { label: 'Effective Date', field: 'effectiveDate' },
  {
    label: 'Calculation Method', field: 'calculationMethod', showLabelToolTip: true, showValueToolTip: true
  },
  { label: 'Decimal Places', field: 'decimalPlaces' },
  { label: 'Rounding Method', field: 'roundingMethod', showLabelToolTip: true },
  { label: 'Last Updated By', field: 'lastUpdatedBy' },
  { label: 'Last Updated On', field: 'lastUpdatedDate', showValueToolTip: true },
];

export const ITEM_GROUP_INFO = [
  { label: 'Master Item Group', field: 'masterItemGroup' },
  { label: 'Description', field: 'itemGroupDescription', showValueToolTip: true },
  { label: 'Source Flag', field: 'sourcedItem' },
  { label: 'Category Managed', field: 'categoryManaged', showLabelToolTip: true },
  { label: 'Commodity Flag', field: 'commodityItem' }
];

export const OPCO_EXCEPTION_INFO = [
  { label: 'OPCO Code', field: 'opcoCode' },
  { label: 'OPCO Name', field: 'opcoName' }
];

export const WHSE_EXCEPTION_INFO = [
  { label: 'Warehouse Code', field: 'warehouseCode' },
  { label: 'Warehouse Name', field: 'warehouseName', showLabelToolTip: true }
];

export const SAS_FD_INFO = [
  { label: 'SAS Amount', field: 'sasAmount' },
  { label: 'FD Amount', field: 'fdAmount', showLabelToolTip: true }
];

export const ADHOC_DATA_GRID_HEADERS = [
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'SUVC',
    accessor: 'suvc',
    displayName: 'SUVC',
    type: 'TEXT'
  },
  {
    id: 'SUPPLIER',
    accessor: 'supplier',
    displayName: 'Supplier Vendor Number',
    type: 'TEXT'
  },
  {
    id: 'WAREHOUSE',
    accessor: 'warehouse',
    displayName: 'Warehouse',
    type: 'TEXT'
  },
  {
    id: 'SUPC',
    accessor: 'item',
    displayName: 'SUPC',
    type: 'TEXT'
  },
  {
    id: 'MFG_ID',
    accessor: 'manufactureId',
    displayName: 'MFG-ID',
    type: 'TEXT'
  },
  {
    id: 'BRACKET',
    accessor: 'bracket',
    displayName: 'Bracket',
    type: 'TEXT'
  },
  {
    id: 'SEGMENT_VERSION',
    accessor: 'segmentVersion',
    displayName: 'Segment Version',
    type: 'TEXT'
  },
  {
    id: 'OPCO',
    accessor: 'opco',
    displayName: 'OpCo',
    type: 'TEXT'
  },
  {
    id: 'EFFECTIVE_DATE',
    accessor: 'effectiveDate',
    displayName: 'Effective Date',
    type: 'DATE'
  },
  {
    id: 'CURRENT_SMS_COST',
    accessor: 'currentSmsCost',
    displayName: 'Current Sysco Cost',
    type: 'NUMBER'
  },
  {
    id: 'SMS_COST',
    accessor: 'smsCost',
    displayName: 'Sysco Cost',
    type: 'NUMBER'
  },
  {
    id: 'SMS_COST_DIFF',
    accessor: 'smsCostDiff',
    displayName: '% Difference Sysco Cost',
    type: 'NUMBER'
  },
  {
    id: 'CURRENT_MARKET_PRICE',
    accessor: 'currentMarketPrice',
    displayName: 'Current Market Price',
    type: 'NUMBER'
  },
  {
    id: 'MARKET_PRICE',
    accessor: 'marketPrice',
    displayName: 'Market Price',
    type: 'NUMBER'
  },
  {
    id: 'MARKET_PRICE_DIFF',
    accessor: 'marketPriceDiff',
    displayName: '% Difference Market Price',
    type: 'NUMBER'
  },
  {
    id: 'BUY_BY',
    accessor: 'buyBy',
    displayName: 'Buy By',
    type: 'TEXT'
  },
  {
    id: 'SELL_BY',
    accessor: 'sellBy',
    displayName: 'Sell By',
    type: 'TEXT'
  },
  {
    id: 'NET_WEIGHT',
    accessor: 'netWeight',
    displayName: 'Net Weight',
    type: 'TEXT'
  },
  {
    id: 'PACK',
    accessor: 'pack',
    displayName: 'Pack',
    type: 'TEXT'
  },
  {
    id: 'SIZE',
    accessor: 'itemSize',
    displayName: 'Size',
    type: 'TEXT'
  },
  {
    id: 'BRAND',
    accessor: 'brand',
    displayName: 'Brand',
    type: 'TEXT'
  },
  {
    id: 'DESCRIPTION',
    accessor: 'description',
    displayName: 'Description',
    type: 'TEXT'
  },
  {
    id: 'HOUSE_CODE',
    accessor: 'house',
    displayName: 'House Code',
    type: 'TEXT'
  },
  {
    id: 'CALC_METHOD',
    accessor: 'calculationMethod',
    displayName: 'Calculation Method',
    type: 'TEXT'
  },
  {
    id: 'SOURCE_INDICATOR',
    accessor: 'sourced',
    displayName: 'Sourced',
    type: 'TEXT'
  },
  {
    id: 'OWNED_INDICATOR',
    accessor: 'owned',
    displayName: 'Owned',
    type: 'TEXT'
  },
];

export const SUGGESTED_SQUEEZE_GRID_HEADERS = [
  {
    colId: 'SQUEEZE_AMOUNT',
    headerName: 'Squeeze Amount',
    field: 'squeezedAmount',
    minWidth: 140,
  },
  {
    colId: 'SUGGESTED_MARKET_PRICE',
    headerName: 'Suggested Market Price',
    field: 'suggestedSell',
    minWidth: 140,
  }
];

export const ORIGINAL_COST_SELL_INPUT_GRID_HEADERS = [
  {
    colId: 'ORIGINAL_MARKET_PRICE',
    field: 'originalInputMarketPrice',
    headerName: 'Original Market Price',
    type: 'NUMBER',
    minWidth: 140,
  },
  {
    colId: 'ORIGINAL_SMS_COST',
    field: 'originalInputSmsCost',
    headerName: 'Original Sysco Cost',
    type: 'NUMBER',
    minWidth: 140,
  }
];

export const MARKET_GROUP_COST_GRID_HEADERS = [
  {
    id: 'MARKET_GROUP_RATE',
    accessor: 'marketGroupRate',
    displayName: 'Market Group Rate',
    type: 'TEXT',
    minWidth: 140
  },
  {
    id: 'MARKET_GROUP_RATE_BASIS',
    accessor: 'marketGroupRateBasis',
    displayName: 'Market Group Rate Basis',
    type: 'TEXT',
    minWidth: 140
  },
  {
    id: 'OVERAGE_RATE',
    accessor: 'overage',
    displayName: 'Overage Rate',
    type: 'TEXT',
    minWidth: 140
  },
];

export const INVALID_RECORDS_GRID_HEADERS = [
  {
    id: 'ERROR_MESSAGE',
    accessor: 'errorMessage',
    displayName: 'Error Message',
    type: 'TEXT',
    columnWidth: 300,
    pinColumn: 'right',
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'SUPPLIER',
    accessor: 'supplier',
    displayName: 'Supplier Vendor Number',
    type: 'TEXT'
  },
  {
    id: 'WAREHOUSE',
    accessor: 'warehouse',
    displayName: 'Warehouse',
    type: 'TEXT'
  },
  {
    id: 'SUPC',
    accessor: 'item',
    displayName: 'SUPC',
    type: 'TEXT'
  },
  {
    id: 'BRACKET',
    accessor: 'bracket',
    displayName: 'Bracket',
    type: 'TEXT'
  },
  {
    id: 'SEGMENT_VERSION',
    accessor: 'segmentVersion',
    displayName: 'Segment Version',
    type: 'TEXT'
  },
  {
    id: 'OPCO',
    accessor: 'opco',
    displayName: 'OpCo',
    type: 'TEXT'
  },
  {
    id: 'EFFECTIVE_DATE',
    accessor: 'effectiveDate',
    displayName: 'Effective Date',
    type: 'TEXT'
  },
  {
    id: 'SMS_COST',
    accessor: 'smsCost',
    displayName: 'Sysco Cost',
    type: 'TEXT'
  },
  {
    id: 'MARKET_PRICE',
    accessor: 'marketPrice',
    displayName: 'Market Price',
    type: 'TEXT'
  },
  {
    id: 'HOUSE_CODE',
    accessor: 'house',
    displayName: 'House Code',
    type: 'TEXT'
  },
];

export const KEY_DISPLAY_COLUMN_HEADERS = {
  rowId: 'Row ID',
  supplier: 'Supplier Vendor Number',
  warehouse: 'Warehouse',
  item: 'SUPC',
  bracket: 'Bracket/Contract',
  effectiveDate: 'Effective Date',
  smsCost: 'Sysco Cost',
  marketPrice: 'Market Price',
  house: 'House Code',
  calculationMethod: 'Calculation Method'
};

export const KEY_COLUMN_ID = {
  rowId: 'ROW_ID',
  supplier: 'SUPPLIER',
  warehouse: 'WAREHOUSE',
  item: 'SUPC',
  bracket: 'BRACKET',
  effectiveDate: 'EFFECTIVE_DATE',
  smsCost: 'SMS_COST',
  marketPrice: 'MARKET_PRICE',
  house: 'HOUSE_CODE',
  calculationMethod: 'CALC_METHOD'
};

export const BASE12_FILE_COLUMN_HEADERS = [
  'SUVC',
  'SUVC Name',
  'Purchasing Entity',
  'Agreement Number',
  'Base12 Value'
];

export const COST_STAGING_ADHOC_DATA_GRID_HEADERS = [
  {
    id: KEY_COLUMN_ID.rowId,
    accessor: 'rowId',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.rowId,
    type: 'TEXT',
    minWidth: 80,
    pinColumn: 'left',
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'SUVC',
    accessor: 'suvc',
    displayName: 'SUVC',
    type: 'TEXT',
    hide: true,
  },
  {
    id: KEY_COLUMN_ID.supplier,
    accessor: 'supplier',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.supplier,
    type: 'TEXT',
    headerTooltip: true,
  },
  {
    id: KEY_COLUMN_ID.warehouse,
    accessor: 'warehouse',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.warehouse,
    type: 'TEXT'
  },
  {
    id: KEY_COLUMN_ID.item,
    accessor: 'item',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.item,
    type: 'TEXT'
  },
  {
    id: 'MFG_ID',
    accessor: 'manufactureId',
    displayName: 'MFG-ID',
    type: 'TEXT'
  },
  {
    id: KEY_COLUMN_ID.bracket,
    accessor: 'bracket',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.bracket,
    type: 'TEXT'
  },
  {
    id: 'SEGMENT_VERSION',
    accessor: 'segmentVersion',
    displayName: 'Segment Version',
    type: 'TEXT'
  },
  {
    id: 'OPCO',
    accessor: 'opco',
    displayName: 'OpCo',
    type: 'TEXT'
  },
  {
    id: KEY_COLUMN_ID.effectiveDate,
    accessor: 'effectiveDate',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.effectiveDate,
    type: 'DATE'
  },
  {
    id: 'OLD_BSCC_SPC_COST',
    accessor: 'currentCalculatedCost',
    displayName: 'Current Calculated Cost',
    type: 'NUMBER',
    headerTooltip: true,
  },
  {
    id: 'NEW_BSCC_SPC_COST',
    accessor: 'calculatedCost',
    displayName: 'Calculated Cost',
    type: 'NUMBER'
  },
  {
    id: 'BSCC_SPC_COST_DIFF',
    accessor: 'calculatedCostDiff',
    displayName: '% Diff of Calculated Cost',
    type: 'NUMBER',
    headerTooltip: true,
  },
  {
    id: 'CURRENT_SMS_COST',
    accessor: 'currentSmsCost',
    displayName: 'Current Sysco Cost',
    type: 'NUMBER',
    headerTooltip: true,
  },
  {
    id: KEY_COLUMN_ID.smsCost,
    accessor: 'smsCost',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.smsCost,
    type: 'NUMBER'
  },
  {
    id: 'SMS_COST_DIFF',
    accessor: 'smsCostDiff',
    displayName: '% Difference Sysco Cost',
    type: 'NUMBER',
    headerTooltip: true,
  },
  {
    id: 'CURRENT_MARKET_PRICE',
    accessor: 'currentMarketPrice',
    displayName: 'Current Market Price',
    type: 'NUMBER',
    headerTooltip: true,
  },
  {
    id: KEY_COLUMN_ID.marketPrice,
    accessor: 'marketPrice',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.marketPrice,
    type: 'NUMBER'
  },
  {
    id: 'MARKET_PRICE_DIFF',
    accessor: 'marketPriceDiff',
    displayName: '% Difference Market Price',
    type: 'NUMBER',
    headerTooltip: true,
  },
  {
    id: 'BUY_BY',
    accessor: 'buyBy',
    displayName: 'Buy By',
    type: 'TEXT'
  },
  {
    id: 'SELL_BY',
    accessor: 'sellBy',
    displayName: 'Sell By',
    type: 'TEXT'
  },
  {
    id: 'NET_WEIGHT',
    accessor: 'netWeight',
    displayName: 'Net Weight',
    type: 'TEXT'
  },
  {
    id: 'PACK',
    accessor: 'pack',
    displayName: 'Pack',
    type: 'TEXT'
  },
  {
    id: 'SIZE',
    accessor: 'itemSize',
    displayName: 'Size',
    type: 'TEXT'
  },
  {
    id: 'BRAND',
    accessor: 'brand',
    displayName: 'Brand',
    type: 'TEXT'
  },
  {
    id: 'DESCRIPTION',
    accessor: 'description',
    displayName: 'Description',
    type: 'TEXT'
  },
  {
    id: KEY_COLUMN_ID.house,
    accessor: 'house',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.house,
    type: 'TEXT'
  },
  {
    id: KEY_COLUMN_ID.calculationMethod,
    accessor: 'calculationMethod',
    displayName: KEY_DISPLAY_COLUMN_HEADERS.calculationMethod,
    type: 'TEXT',
    headerTooltip: true,
  },
  {
    id: 'SOURCE_INDICATOR',
    accessor: 'sourced',
    displayName: 'Sourced',
    type: 'TEXT'
  },
  {
    id: 'OWNED_INDICATOR',
    accessor: 'owned',
    displayName: 'Owned',
    type: 'TEXT'
  },
  {
    id: 'DISPLAY_MODE',
    accessor: 'displayMode',
    displayName: 'Display Mode',
    type: 'TEXT'
  },
  {
    id: 'WEIGHT_INDICATOR',
    accessor: 'weightIndicator',
    displayName: 'Weight Indicator',
    type: 'TEXT'
  },
  {
    id: 'GROSS_WEIGHT',
    accessor: 'grossWeight',
    displayName: 'Gross Weight',
    type: 'TEXT'
  },
  {
    id: 'MESSAGE',
    accessor: 'message',
    displayName: 'Status',
    type: 'TEXT',
    minWidth: 140,
    pinColumn: 'right',
  },
  {
    id: 'ITEM_REJECT',
    accessor: 'rejected',
    displayName: 'Rejected',
    minWidth: 90,
    pinColumn: 'right',
  },
  {
    id: 'COMMENT',
    accessor: 'comment',
    displayName: 'Comment',
    type: 'TEXT',
    minWidth: 120,
    pinColumn: 'right',
  }
];

export const ADHOC_VARIATION_DATA_GRID_HEADERS = [
  {
    id: 'ROW_ID',
    accessor: 'rowId',
    displayName: 'Row ID',
    type: 'TEXT'
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'HOUSE_CODE',
    accessor: 'house',
    displayName: 'House Code',
    type: 'TEXT'
  },
  {
    id: 'BRACKET',
    accessor: 'bracket',
    displayName: 'Bracket',
    type: 'TEXT'
  },
  {
    id: 'SEGMENT_VERSION',
    accessor: 'segmentVersion',
    displayName: 'Segment Version',
    type: 'TEXT'
  },
  {
    id: 'SUPC',
    accessor: 'item',
    displayName: 'SUPC',
    type: 'TEXT'
  },
  {
    id: 'WAREHOUSE',
    accessor: 'warehouse',
    displayName: 'Warehouse',
    type: 'TEXT'
  },
  {
    id: 'SUPPLIER',
    accessor: 'supplier',
    displayName: 'Supplier Vendor Number',
    type: 'TEXT'
  },
  {
    id: 'OPCO_NAME',
    accessor: 'opco',
    displayName: 'OpCo',
    type: 'TEXT'
  },
  {
    id: 'MFG_ID',
    accessor: 'manufactureId',
    displayName: 'MFG-ID',
    type: 'TEXT'
  },
  {
    id: 'BRAND',
    accessor: 'brand',
    displayName: 'Brand',
    type: 'TEXT'
  },
  {
    id: 'PACK',
    accessor: 'pack',
    displayName: 'Pack',
    type: 'TEXT'
  },
  {
    id: 'SIZE',
    accessor: 'itemSize',
    displayName: 'Size',
    type: 'TEXT'
  },
  {
    id: 'DISPLAY_MODE',
    accessor: 'displayMode',
    displayName: 'Display Mode',
    type: 'TEXT'
  },
  {
    id: 'WEIGHT_INDICATOR',
    accessor: 'weightIndicator',
    displayName: 'Weight Indicator',
    type: 'TEXT'
  },
  {
    id: 'DESCRIPTION',
    accessor: 'description',
    displayName: 'Description',
    type: 'TEXT'
  },
  {
    id: 'NET_WEIGHT',
    accessor: 'netWeight',
    displayName: 'Net Weight',
    type: 'TEXT'
  },
  {
    id: 'GROSS_WEIGHT',
    accessor: 'grossWeight',
    displayName: 'Gross Weight',
    type: 'TEXT'
  },
  {
    id: 'EFFECTIVE_DATE',
    accessor: 'effectiveDate',
    displayName: 'Effective Date',
    type: 'DATE'
  },
  {
    id: 'OLD_VENDOR_COST',
    accessor: 'oldVendorCost',
    displayName: 'Old Vendor Cost',
    type: 'NUMBER'
  },
  {
    id: 'NEW_VENDOR_COST',
    accessor: 'newVendorCost',
    displayName: 'New Vendor Cost',
    type: 'NUMBER'
  },
  {
    id: 'VENDOR_COST_DIFF',
    accessor: 'vendorCostDiff',
    displayName: '% Difference of Vendor Cost',
    type: 'NUMBER'
  },
  {
    id: 'OLD_BSCC_SPC_COST',
    accessor: 'oldBsccSpcCost',
    displayName: 'Old BSCC SPC Cost',
    type: 'NUMBER'
  },
  {
    id: 'NEW_BSCC_SPC_COST',
    accessor: 'newBsccSpcCost',
    displayName: 'New BSCC SPC Cost',
    type: 'NUMBER'
  },
  {
    id: 'BSCC_SPC_COST_DIFF',
    accessor: 'bsccSpcCostDiff',
    displayName: '% Diff of BSCC SPC Cost',
    type: 'NUMBER'
  },
  {
    id: 'OLD_SELL/MARKET_PRICE',
    accessor: 'oldSellMarketPrice',
    displayName: 'Old Sell/Market Price',
    type: 'NUMBER'
  },
  {
    id: 'NEW_SELL/MARKET_PRICE',
    accessor: 'newSellMarketPrice',
    displayName: 'New Sell/Market Price',
    type: 'NUMBER'
  },
  {
    id: 'SELL/MARKET_PRICE_DIFF',
    accessor: 'bsccSpcCostDiff',
    displayName: '% Diff of Sell/Market Price',
    type: 'NUMBER'
  },
  {
    id: 'MESSAGE',
    accessor: 'message',
    displayName: 'MESSAGE',
    type: 'TEXT'
  },
];

export const ADHOC_EXCEPTION_DATA_GRID_HEADERS = [
  {
    id: 'ROW_ID',
    accessor: 'rowId',
    displayName: 'Row ID',
    type: 'TEXT'
  },
  {
    id: 'SUPPLIER',
    accessor: 'supplier',
    displayName: 'Supplier Vendor Number',
    type: 'TEXT'
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'SUPC',
    accessor: 'item',
    displayName: 'SUPC',
    type: 'TEXT'
  },
  {
    id: 'WAREHOUSE',
    accessor: 'warehouse',
    displayName: 'Warehouse',
    type: 'TEXT'
  },
  {
    id: 'OPCO_NAME',
    accessor: 'opcoAbbreviation',
    displayName: 'OpCo',
    type: 'TEXT'
  },
  {
    id: 'HOUSE_CODE',
    accessor: 'houseCode',
    displayName: 'House Code',
    type: 'TEXT'
  },
  {
    id: 'BEGIN_DATE',
    accessor: 'beginningDate',
    displayName: 'Beginning Date',
    type: 'DATE'
  },
  {
    id: 'END_DATE',
    accessor: 'endDate',
    displayName: 'End Date',
    type: 'DATE'
  },
  {
    id: 'SELL',
    accessor: 'sell',
    displayName: 'Sell',
    type: 'NUMBER'
  },
  {
    id: 'COST',
    accessor: 'cost',
    displayName: 'Cost',
    type: 'NUMBER'
  },
  {
    id: 'CALCULATED_COST',
    accessor: 'calculatedCost',
    displayName: 'Calculated Cost',
    type: 'NUMBER'
  },
  {
    id: 'EXCEPTION',
    accessor: 'exception',
    displayName: 'Exception',
    type: 'TEXT'
  }
];

export const ADHOC_NOT_IMPORTED_DATA_GRID_HEADERS = [
  {
    id: 'ROW_ID',
    accessor: 'rowId',
    displayName: 'Row ID',
    type: 'TEXT'
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'SUPC',
    accessor: 'item',
    displayName: 'Item',
    type: 'TEXT'
  },
  {
    id: 'USER_ID',
    accessor: 'userId',
    displayName: 'User ID',
    type: 'TEXT'
  },
  {
    id: 'SUPPLIER',
    accessor: 'supplier',
    displayName: 'Supplier',
    type: 'TEXT'
  },
  {
    id: 'PRICE_CODE',
    accessor: 'priceCode',
    displayName: 'Price Code',
    type: 'TEXT'
  }
];

export const ADHOC_SUB_REQUESTS_GRID_COLUMNS = [
  {
    Header: '',
    accessor: 'view_request',
    sortable: false,
    filterable: false,
    maxWidth: 50,
  },
  {
    Header: 'Sub Request ID',
    accessor: 'sub_request_id',
    minWidth: 140,
  }, {
    Header: 'Business Center',
    accessor: 'business_center',
    minWidth: 110,
  },
  {
    Header: 'Status',
    accessor: 'sub_request_status',
    minWidth: 140,
  },
  {
    Header: 'Updated On',
    accessor: 'updated_on',
    minWidth: 130,
  },
  {
    Header: 'Approvers',
    accessor: 'approvers',
    sortable: false,
    filterable: false,
    minWidth: 190,
  },
  {
    accessor: 'messages',
    sortable: false,
    filterable: false,
    minWidth: 140,
  },
  {
    Header: 'Actions',
    accessor: 'request_actions',
    sortable: false,
    filterable: false,
    minWidth: 180,
    style: { whiteSpace: 'unset' }
  },
  {
    accessor: 'cost_data_records',
    sortable: false,
    filterable: false,
    minWidth: 130,
  }
];

export const DEFAULT_SUB_REQUESTS_GRID_COLUMNS = [
  {
    Header: '',
    accessor: 'view_request',
    sortable: false,
    filterable: false,
    maxWidth: 50,
  },
  {
    Header: 'Sub Request ID',
    accessor: 'sub_request_id',
    minWidth: 140,
  },
  {
    Header: 'Status',
    accessor: 'sub_request_status',
    minWidth: 140,
  },
  {
    Header: 'Updated On',
    accessor: 'updated_on',
    minWidth: 130,
  },
  {
    accessor: 'messages',
    sortable: false,
    filterable: false,
    minWidth: 140,
  }
];

export const COST_CHANGE_DRIVERS = {
  PRODUCT_COST_CHANGE: {
    label: 'Product Cost Change',
    value: 'PRODUCT_COST_CHANGE',
    additionalDataType: 'SUB_OPTIONS',
    subOptions: {
      COMMODITY_MARKET_CHANGE: { label: 'Commodity Market Change', value: 'COMMODITY_MARKET_CHANGE' },
      RAW_MATERIAL_COST: { label: 'Raw Material Cost', value: 'RAW_MATERIAL_COST' },
      MARKET_COMPETITION: { label: 'Market Competition', value: 'MARKET_COMPETITION' },
    },
  },
  PRICE_CORRECTION: {
    label: 'Price Correction',
    value: 'PRICE_CORRECTION'
  },
  MISSED_ITEM_ON_PREV_APPROVED_CHANGE: {
    label: 'Missed Item on Previous Approved Change',
    value: 'MISSED_ITEM_ON_PREV_APPROVED_CHANGE',
    additionalDataType: 'DATE'
  },
  AVAILABILITY_SUB_REPLACE_ITEM: {
    label: 'Availability Sub/Replace Item',
    value: 'AVAILABILITY_SUB_REPLACE_ITEM'
  },
  PROPRIETARY_COST_CHANGE: {
    label: 'Proprietary Cost Change',
    value: 'PROPRIETARY_COST_CHANGE'
  },
  AGREEMENT_CHANGE: {
    label: 'Agreement Change',
    value: 'AGREEMENT_CHANGE'
  },
  NEW_ITEMS: {
    label: 'New Item(s)',
    value: 'NEW_ITEMS'
  }
};

export const VARIANCE_LIMITS = {
  UPPER_LIMIT: 50,
  LOWER_LIMIT: 20
};

export const SAS_FD_ITEM_DATA_GRID_HEADERS = [
  {
    id: 'OPCO',
    accessor: 'houseCode',
    displayName: 'OPCO',
    type: 'TEXT'
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'Warehouse',
    accessor: 'warehouse',
    displayName: 'Warehouse',
    type: 'TEXT'
  },
  {
    id: 'SUPC',
    accessor: 'item',
    displayName: 'SUPC',
    type: 'TEXT'
  },
  {
    id: 'SELL_BY',
    accessor: 'sellBy',
    displayName: 'Sell By',
    type: 'TEXT'
  },
  {
    id: 'NET_WEIGHT',
    accessor: 'netWeight',
    displayName: 'Net Weight',
    type: 'TEXT'
  },
  {
    id: 'FREIGHT_DIFFERENCE',
    accessor: 'freightDifference',
    displayName: 'Freight Difference',
    type: 'TEXT'
  },
  {
    id: 'SAS',
    accessor: 'sas',
    displayName: 'SAS',
    type: 'TEXT'
  },
  {
    id: 'NO_SAS',
    accessor: 'noSas',
    displayName: 'No SAS',
    type: 'TEXT'
  },
  {
    id: 'SEND_NEGATIVE',
    accessor: 'sendNeg',
    displayName: 'Send Negative',
    type: 'TEXT'
  },
  {
    id: 'MODIFIED_DATE',
    accessor: 'modifyDate',
    displayName: 'Modified Date',
    type: 'TEXT'
  },
  {
    id: 'IMPORTED_DATE',
    accessor: 'importDate',
    displayName: 'Imported Date',
    type: 'TEXT'
  },
];

export const WORKSPACE_SEARCH = {
  WORKSPACE_SEARCH_TYPE: {
    NORMAL_SEARCH: 'NORMAL_SEARCH',
    ADVANCED_SEARCH: 'ADVANCED_SEARCH'
  },
  DEFAULT_SEARCH_TYPE: 'NORMAL_SEARCH',
  DEFAULT_SPAN: '3',
  CHANGE_SET: {
    VENDOR_COST_ADHOC: 'VENDOR COST ADHOC (VCI)',
    VENDOR_COST_CATALOG: 'SUPPLIER CATALOG CHANGE (VCC)',
    COMMODITY_COST_CHANGE: 'COMMODITY COST CHANGE (COM)',
    RECALCULATION: 'RECALCULATION (RCL)',
    ITEM_GROUP_MASS_ITEM_UPLOAD: 'ITEM GROUP MASS ITEM UPLOAD (IGM)',
    REVIEW_IP: 'REVIEW IN PROGRESS'
  },
  EXCLUDED_REQUEST_TYPES: [REQUEST_TYPES.VENDOR_AGREEMENT_AUDIT],
  EXCLUDED_REQUEST_STATUS_TYPES: [REQUEST_STATUS_TYPES.REVIEWED],
  EXTERNAL_USER_EXCLUDED_REQUEST_TYPES: [
    REQUEST_TYPES.BIS_COST_CHANGE,
    REQUEST_TYPES.SYGMA_COST_CHANGE,
    REQUEST_TYPES.COMMODITY_COST_CHANGE,
    REQUEST_TYPES.RECALCULATION,
    REQUEST_TYPES.ITEM_GROUP_MASS_ITEM_UPLOAD,
    REQUEST_TYPES.MARKET_GROUP_MAINTENANCE,
    REQUEST_TYPES.MARKET_GROUP_PRICING,
  ],
  EXTERNAL_USER_EXCLUDED_REQUEST_STATUS_TYPES: []
};
export const BASIS_OPTIONS = [
  { label: '%', value: '%' },
  { label: '*', value: '*' },
  { label: 'Case', value: 'Case' },
  { label: 'Cube', value: 'Cube' },
  { label: 'Each', value: 'Each' },
  { label: 'GrWt', value: 'GrWt' },
  { label: 'LB', value: 'LB' },
  { label: 'NtWt', value: 'NtWt' },
];

export const ADD_BASIS_OPTIONS = [
  { label: '%', value: '%' },
  { label: '*', value: '*' },
  { label: '@', value: '@' },
  { label: 'Case', value: 'Case' },
  { label: 'Cube', value: 'Cube' },
  { label: 'Each', value: 'Each' },
  { label: 'GrWt', value: 'GrWt' },
  { label: 'LB', value: 'LB' },
  { label: 'NtWt', value: 'NtWt' },
];

export const FACTOR_OPTIONS = [
  { label: 'Net Base', value: 'Net Base' },
  { label: 'SMS Cost', value: 'SMS Cost' },
  { label: 'SMS Sell', value: 'SMS Sell' }
];

export const FACTORS = {
  NET_BASE: 'Net Base',
  SMS_COST: 'SMS Cost',
  SMS_SELL: 'SMS Sell'
};

export const RATE_DECIMAL_PLACE = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
];

export const ROUNDING_VALUES = [
  { value: 'NR', label: 'No Rounding' },
  { value: 'HR', label: 'Half' },
  { value: 'WH', label: 'Whole' },
];

export const CALCULATION_TYPES = [
  { value: 'COST_PLUS', label: 'Cost Plus' },
  { value: 'SELL_MINUS', label: 'Sell Minus' },
  { value: 'SPC', label: 'SPC' },
  { value: 'COST_PLUS_VARIATION', label: 'Cost Plus Variation' },
  { value: 'SQUEEZE', label: 'Squeeze' }
];

export const CALC_METHODS = {
  SELL_MINUS: 'SELL_MINUS',
  COST_PLUS: 'COST_PLUS',
  SPC: 'SPC',
  COST_PLUS_VARIATION: 'COST_PLUS_VARIATION',
  SQUEEZE: 'SQUEEZE',
};

export const PURCHASING_ENTITIES = [
  { value: 'Broadline', label: 'Broadline' },
  { value: 'RDC', label: 'RDC' }
];

export const BUSINESS_CENTER_OPTIONS = [
  { value: 'BEEF', label: 'BEEF' },
  { value: 'GROC', label: 'GROC' },
  { value: 'CONV', label: 'CONV' },
  { value: 'PORK', label: 'PORK' },
  { value: 'DISP', label: 'DISP' },
  { value: 'DAIRY', label: 'DAIRY' },
  { value: 'FATS', label: 'FATS' },
  { value: 'SEAFD', label: 'SEAFD' },
  { value: 'BFPRPD', label: 'BFPRPD' },
  { value: 'BEV', label: 'BEV' },
  { value: 'POT', label: 'POT' },
  { value: 'BAKE', label: 'BAKE' },
  { value: 'CHEM', label: 'CHEM' },
  { value: 'SUPP', label: 'SUPP' },
  { value: 'VEG', label: 'VEG' },
  { value: 'CAN', label: 'CAN' },
  { value: 'ESALES', label: 'ESALES' },
  { value: 'PLTRY', label: 'PLTRY' },
  { value: 'TXPROD', label: 'TXPROD' },
  { value: 'DDAIRY', label: 'DDAIRY' },
  { value: 'BRAND', label: 'BRAND' },
];

export const AGREEMENT_TERMS = {
  VENDOR_DISCOUNT: 'Vendor Discount',
  VENDOR_ALLOW: 'Vendor Allow',
  SMR: 'SMR',
  OPCO_FUND: 'OPCO Fund',
  OVERHEAD: 'Overhead',
  BRAND_MANAGER: 'Brand Manager',
  PROMO: 'Promo',
  CASH_DISC_DIFF: 'Cash Disc Diff',
  ADDITIONAL_SMR: 'Additional SMR',
  QA: 'QA',
  BASE_11: 'Base 11',
  BASE_12: 'Base 12',
  OPCO_PROMO_FUND: 'OPCO Promo Fund'
};

export const EARNED_INCOME_ACTIONS = {
  DELETE: 'DELETE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE'
};

export const ITEM_GROUP_MASS_UPLOAD_DATA_GRID_HEADERS = [
  {
    id: 'AGREEMENT',
    accessor: 'agreementId',
    displayName: 'Agreement Number',
    type: 'TEXT'
  },
  {
    id: 'ITEM_GROUP',
    accessor: 'itemGroupId',
    displayName: 'Item Group',
    type: 'TEXT'
  },
  {
    id: 'ITEM',
    accessor: 'item',
    displayName: 'Item',
    type: 'TEXT'
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'MFG',
    accessor: 'mfgCode',
    displayName: 'Manufacturing Code',
    type: 'TEXT',
    minWidth: 100
  },
  {
    id: 'BRAND',
    accessor: 'brand',
    displayName: 'Brand',
    type: 'TEXT',
    minWidth: 140
  },
  {
    id: 'DESC',
    accessor: 'description',
    displayName: 'Description',
    type: 'TEXT',
    minWidth: 275,
  },
  {
    id: 'ACTION',
    accessor: 'action',
    displayName: 'Action',
    type: 'TEXT',
    pinColumn: 'right',
    minWidth: 80
  },
  {
    id: 'MESSAGE',
    accessor: 'errorMessage',
    displayName: 'Error Message',
    type: 'TEXT',
    pinColumn: 'right',
    minWidth: 300,
  },
];

export const AGREEMENT_REPORT_TYPES = {
  BASIS_DISCREPANCY_AD: {
    label: 'Basis Discrepancy',
    location: 'CDM Dashboard > Explorer > Agreements > Basis Discrepancy'
  },
  ITEM_GROUPING: {
    label: 'Item Grouping',
    location: 'CDM Dashboard > Explorer > Agreements > Item Grouping'
  },
  AGREEMENT_SUMMARY_AD: {
    label: 'Agreement Summary',
    location: 'CDM Dashboard > Explorer > Agreements > Agreement Summary'
  }
};

export const ITEM_GROUP_ITEM_DATA_GRID_HEADERS = [
  {
    id: 'AGREEMENT_ID',
    accessor: 'agreementId',
    displayName: 'Agreement Number',
    type: 'TEXT',
    minWidth: 200,
  },
  {
    id: 'ITEM_GROUP_ID',
    accessor: 'itemGroupId',
    displayName: 'Item Group Number',
    type: 'TEXT',
    minWidth: 200,
  },
  {
    id: 'ITEM',
    accessor: 'item',
    displayName: 'SUPC',
    type: 'TEXT',
    minWidth: 150,
  },
  {
    id: 'BUSINESS_CENTER',
    accessor: 'businessCenter',
    displayName: 'Business Center',
    type: 'TEXT'
  },
  {
    id: 'MFG_ID',
    accessor: 'mfgCode',
    displayName: 'MFG ID',
    type: 'TEXT'
  },
  {
    id: 'BRAND',
    accessor: 'brand',
    displayName: 'Brand',
    type: 'TEXT',
    minWidth: 80
  },
  {
    id: 'DESC',
    accessor: 'description',
    displayName: 'Description',
    type: 'TEXT',
    minWidth: 200,
  },
  {
    id: 'ACTION',
    accessor: 'action',
    displayName: 'Action',
    type: 'TEXT',
    pinColumn: 'right',
    minWidth: 125
  },
  {
    id: 'MESSAGE',
    accessor: 'errorMessage',
    displayName: 'Error Message',
    type: 'TEXT',
    pinColumn: 'right',
    minWidth: 300,
  },
];

export const OPCO_EXCEPTION_TERMS = {
  MARKET_SMR: 'Market SMR',
  OWNED_EQUIP: 'Owned Equip',
  LEASED_EQUIP: 'Leased Equip',
  MARKETING_FUND: 'Marketing Fund',
  MISC_OPCO_1: 'Misc OpCo 1',
  MISC_OPCO_2: 'Misc OpCo 2'
};

export const WAREHOUSE_EXCEPTION_TERMS = {
  HANDLING: 'Handling',
  STORAGE: 'Storage',
  INTEREST: 'Interest',
  FREIGHT_IN: 'Freight In',
  MISC_WHSE_1: 'Misc Whse 1',
  MISC_WHSE_2: 'Misc Whse 2'
};

export const HOUSE_INDICATOR = {
  OPCO: 'H',
  WAREHOUSE: 'W'
};

export const FORMULA_GROUP_MAINTENANCE = {
  BASIS_TYPE: {
    LB: 'Pound (LB)',
    CS: 'Case (CS)'
  },
  FREQUENCY_TYPE: {
    WEEKLY: 'Weekly',
    DAILY: 'Daily'
  },
  RATE_TYPE: {
    CLOSE_PRICE: 'Close Price',
    WEEKLY_AVERAGE: 'Weekly Average'
  }
};

export const FORMULA_GROUP_ITEM_DATA_GRID_HEADERS = [
  {
    id: 'SMG_CODE',
    accessor: 'marketGroupCode',
    displayName: 'SMG Code',
    type: 'TEXT'
  },
  {
    id: 'SMG_Name',
    accessor: 'marketGroupName',
    displayName: 'SMG Name',
    type: 'TEXT',
    minWidth: 200,
  },
  {
    id: 'ITEM',
    accessor: 'item',
    displayName: 'Item',
    type: 'TEXT'
  },
  {
    id: 'VENDOR',
    accessor: 'vendor',
    displayName: 'Vendor',
    type: 'TEXT'
  },
  {
    id: 'WHSE',
    accessor: 'warehouse',
    displayName: 'Warehouse',
    type: 'TEXT'
  },
  {
    id: 'PACK',
    accessor: 'pack',
    displayName: 'Pack',
    type: 'TEXT',
    minWidth: 80
  },
  {
    id: 'SIZE',
    accessor: 'size',
    displayName: 'Size',
    type: 'TEXT',
    minWidth: 100
  },
  {
    id: 'BRAND',
    accessor: 'brand',
    displayName: 'Brand',
    type: 'TEXT',
    minWidth: 140
  },
  {
    id: 'DESC',
    accessor: 'description',
    displayName: 'Description',
    type: 'TEXT',
    minWidth: 275,
  },
  {
    id: 'ACTION',
    accessor: 'action',
    displayName: 'Action',
    type: 'TEXT',
    pinColumn: 'right',
    minWidth: 80
  },
  {
    id: 'MESSAGE',
    accessor: 'errorMessage',
    displayName: 'Error Message',
    type: 'TEXT',
    pinColumn: 'right',
    minWidth: 300,
  },
];

export const FORMULA_GROUP_ITEM_DATA_TABLE_HEADERS = [
  {
    Header: 'Item',
    accessor: 'item',
    filterable: true,
    sortable: false,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Vendor',
    accessor: 'vendor',
    filterable: true,
    sortable: false,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Warehouse',
    accessor: 'warehouse',
    sortable: false,
    filterable: true,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Pack',
    accessor: 'pack',
    sortable: false,
    filterable: true,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Size',
    accessor: 'size',
    sortable: false,
    filterable: true,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Brand',
    accessor: 'brand',
    sortable: false,
    filterable: true,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Description',
    accessor: 'description',
    sortable: false,
    filterable: true,
    resizable: true,
    minWidth: 150,
  },
  {
    Header: 'Assigned By',
    accessor: 'assignedBy',
    sortable: false,
    filterable: true,
    resizable: true,
    width: 150,
  },
  {
    Header: 'Assigned Date',
    accessor: 'assignedAt',
    sortable: false,
    filterable: true,
    resizable: true,
    width: 150,
  }
];

export const PRICE_UPLOAD_TEMPLATE_COLUMNS = {
  module_id: 'Module ID',
  comm_id: 'Comm ID',
  area_id: 'Loading Area ID',
  module_code: 'Module Name',
  comm_desc: 'Commodity Group Name',
  pack: 'Pack',
  size: 'Size',
  area_code: 'Area',
  price: 'Price',
  start_date: 'Start Date',
};

export const RECORD_STATUS = {
  active: 'A',
  inactive: 'I',
  delete: 'D',
};

export const ROUTES = {
  PRICE_MODULE: {
    path: '/cost-maintenance/price-module',
    name: 'Cost Maintenance / Price Module',
  },
};

export const VALUE_MAPPER = {
  CS: 'CS',
  LB: 'LB',
};

export const VENDOR_SELL_METHODS_FOR_ITEM_COST_VIEW_MODEL = {
  FOB: 'FOB',
  DEL: 'DEL',
};

export const COST_DETAILS_TABLE_COLUMN_TYPES = {
  item: DATA_TYPES.TEXT,
  warehouse: DATA_TYPES.TEXT,
  vendor: DATA_TYPES.TEXT,
  vendorName: DATA_TYPES.TEXT,
  suvc: DATA_TYPES.TEXT,
  house: DATA_TYPES.TEXT,
  houseCo3oc: DATA_TYPES.TEXT,
  segmentId: DATA_TYPES.TEXT,
  priceType: DATA_TYPES.TEXT,
  effectiveFrom: DATA_TYPES.DATE,
  effectiveTo: DATA_TYPES.DATE,
  vendorSellMethod: DATA_TYPES.TEXT,
  cost: DATA_TYPES.NUMBER,
  sell: DATA_TYPES.NUMBER,
};

export const SEGMENT_DETAIL_MODES = {
  CREATE: 'CREATE',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
};

export const SEGMENT_DETAIL_ACTION_TYPES = {
  RESET: 'RESET',
  DELETE: 'DELETE',
  RENAME: 'RENAME',
  SET_AS_INACTIVE: 'SET AS INACTIVE',
};

export const SEGMENT_DETAIL_STATUSES = {
  N: 'NEW',
  P: 'PENDING',
  W: 'WAITING FOR TERMINATION',
  A: 'ACTIVE',
  I: 'INACTIVE',
  D: 'PERMANENTLY DELETED',
  AF: 'ACTIVE FAILURE',
  DF: 'DELETE FAILURE',
};

export const SUCCESS_EVENTS = {
  SEGMENT_DETAIL_DELETE: 'SEGMENT_DETAIL_DELETE',
  SEGMENT_DETAIL_INACTIVATE: 'SEGMENT_DETAIL_INACTIVATE',
  FETCH_NEWLY_CREATED_SEGMENT_DETAILS: 'FETCH_NEWLY_CREATED_SEGMENT_DETAILS',
};
